<template>
  <main id="app">
    <router-view />
    <app-footer />
  </main>
</template>

<style lang="scss" src="@/scss/main.scss"></style>

<script>

import AppFooter from "@/components/Footer";

export default {

    components: { AppFooter },
}
</script>
